import Color from "colorjs.io";

const doc = document.documentElement;
const body = document.body;

const getVar = (name, el = doc) => {
  const v = getComputedStyle(el).getPropertyValue(name).trim();
  if (!v) console.error(`variable '${name}' not found`);
  return v;
};

const setVar = (name, val, el = body) => el.style.setProperty(name, val);

const getCssVars = () => {
  const vars = getVar("--color-vars");
  if (!vars) return {};
  return vars
    .split(",")
    .map((v) => `--${v.trim()}`)
    .reduce((acc, n) => {
      const val = getVar(n);
      if (val) acc[n] = val;
      return acc;
    }, {});
};

const readableText = (bg) => {
  const b = new Color(bg);
  const w = new Color("#fff");
  const k = new Color("#000");
  return (b.contrast(w, "WCAG21") >= b.contrast(k, "WCAG21") ? w : k)
    .to("srgb")
    .toString({ format: "hex" });
};

const shade = (c, a) =>
  (a < 0 ? new Color(c).darken(-a) : new Color(c).lighten(a))
    .to("srgb")
    .toString({ format: "hex" });

const createContentColors = (varName, color) => {
  const contrast = readableText(color);
  setVar(`${varName}-content`, contrast);
  setVar(`${varName}-content-i`, readableText(contrast));
};

const getContentColors = () => {
  const vars = getCssVars();
  Object.entries(vars).forEach(([name, value]) => {
    createContentColors(name, value);
    if (name === "--primary" || name === "--secondary") {
      const s1 = shade(value, -0.5);
      const s2 = shade(value, -0.75);
      setVar(`${name}-shade-1`, s1);
      setVar(`${name}-shade-2`, s2);
      createContentColors(`${name}-shade-1`, s1);
      createContentColors(`${name}-shade-2`, s2);
    }
  });
};

const observer = new MutationObserver((mutationList) => {
  for (const m of mutationList) {
    if (m.type === "attributes") {
      getContentColors();
      break;
    }
  }
});

if (doc && body) {
  window.parent.document.dispatchEvent(new CustomEvent("themeDocLoaded", document));
  observer.observe(doc, { attributes: true });
  getContentColors();
} else {
  console.error("problem with color contrast script");
}
